export default "__VITE_ASSET__Dd2t149u__"